import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { ErrorToast } from "../../../../shared/toasters/toasters";
import { AdminNewsLetterService } from "./service";
import { useTranslation } from "react-i18next";
import DraggableBootstrapTable from "../../../../shared/components/draggableList/Draggable";
import { NewsletterSettingsService } from "../../adminNewsletterSettings/service";
// import { N1ED } from "@edsdk/n1ed-react";
// import { Editor } from "tinymce";
import "../../../../assets/scss/EditorStyle.css";
// @ts-ignore
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { InitEditorMulti } from "../../../../shared/tinyMce/InitEditorMulti";
import RichTextEditor from "../../../../shared/editor/RichTextEditor";

export const AdminNewsletterStep2 = ({
  selectedNews,
  setSelectedNews,
  state,
  setState,
  step,
  setCount,
  count,
}: any) => {
  const { t } = useTranslation();

  const [selectEditor, setSelectEditor] = useState<boolean>(false);
  const [editorData, setEditorData] = useState<any>(false);
  const firstLoad = useRef(true);
  const [editorLoading, setEditorLoading] = useState<boolean>(false);
  const changeHandler = (event: any) => {
    const { name, value } = event.target;
    setState((prev: any) => ({ ...prev, [name]: value }));
  };
  // const changeEditorHandler = (content: string, editor: Editor) => {
  //   setState((prev: any) => ({ ...prev, [editor?.id]: content }));
  //   if (!firstLoad.current) {
  //     setEditorData(editor);
  //   }
  //   firstLoad.current = false;
  // };
  const switchHandler = (e: any) => {
    setState((prev: any) => ({ ...prev, [e.target.name]: e.target.checked }));
  };
  const changeHandlerEditor = (value: string, eventName: string) => {
    setState((prev: any) => ({ ...prev, [eventName]: value }));
  };
  const handleTextMr = (textMan: string) => {
    setState((prev: any) => ({ ...prev, textMan }));
  };
  const handleTextWoman = (textWoman: string) => {
    setState((prev: any) => ({ ...prev, textWoman }));
  };
  const handleTextOther = (textOther: string) => {
    setState((prev: any) => ({ ...prev, textOther }));
  };
  useEffect(() => {
    AdminNewsLetterService.getCount()
      .then((response) => {
        const { data } = response;
        setCount(data);
      })
      .catch((error) => ErrorToast(error));
  }, []);
  useEffect(() => {
    if (step === 2) {
      firstLoad.current = true;
      NewsletterSettingsService.getAll()

        .then((response) => {
          setEditorData(false);
          const { data } = response;
          InitEditorMulti(
            state?.textMan ?? data?.textMan ?? undefined,
            handleTextMr,
            ".textMan"
          );
          InitEditorMulti(
            state?.textWoman ?? data?.textWoman ?? undefined,
            handleTextWoman,
            ".textWoman"
          );
          InitEditorMulti(
            state?.textOther ?? data?.textOther ?? undefined,
            handleTextOther,
            ".textOther"
          );
          setState({
            news: state?.news,
            breakingNews: state?.breakingNews ?? false,
            inFocus: state?.inFocus ?? false,
            jobs: state?.jobs ?? false,
            isMarketing: state?.isMarketing ?? false,
            test: state?.test ?? false,
            subject: state?.subject ?? "",
            ...data,
          });
          setEditorLoading((prev: boolean) => !prev);
        })
        .catch((error) => ErrorToast(error));
    } else if (state?.subject) {
      setEditorData(false);
    } else {
      return;
    }
  }, [step]);

  function removeElementsByClass(className: string) {
    const elements = document.getElementsByClassName(className);
    while (elements.length > 0) {
      elements && elements[0]?.parentNode?.removeChild(elements[0]);
    }
    setSelectEditor(false);
  }

  useEffect(() => {
    if (selectEditor) {
      removeElementsByClass(
        "jsplus_theme jsplus_ui_full_screen jsplus_ui_sidebar_widgets jsplus_show"
      );
    }
  }, [selectEditor]);
  return (
    <>
      {step === 2 && state && (
        <>
          <div className="card">
            <div className="card-body">
              <Row>
                <Col md={12} className="mb-3">
                  <label htmlFor="title" className="required-field">
                    {t("newsletter.subject")}
                  </label>
                  <input
                    type="text"
                    name="subject"
                    className="form-control"
                    required
                    onChange={changeHandler}
                    value={state?.id && state?.subject}
                  />
                </Col>
                <Col md={2}>
                  <div className="form-check form-switch p-0">
                    <label
                      className="d-block text-start"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      {t("global.test")} ({t("global.total")}:{" "}
                      {(count as any)?.subscribersTest})
                    </label>
                    <div className="row">
                      <input
                        className="form-check-input switch-custom ms-2 mt-2"
                        type="checkbox"
                        name="test"
                        checked={state?.test}
                        onChange={switchHandler}
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                </Col>
                <Col md={2}>
                  <div className="form-check form-switch p-0">
                    <label
                      className="d-block text-start"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      {t("global.breakingNews")} ({t("global.total")}:{" "}
                      {(count as any)?.subscribers})
                    </label>
                    <div className="row">
                      <input
                        className="form-check-input switch-custom ms-2 mt-2"
                        type="checkbox"
                        name="breakingNews"
                        checked={state?.breakingNews}
                        onChange={switchHandler}
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                </Col>
                <Col md={2}>
                  <div className="form-check form-switch p-0">
                    <label
                      className="d-block text-start"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      {t("global.special_newsletter")}
                      {/* {(count as any)?.subscribers} */}
                    </label>
                    <div className="row">
                      <input
                        className="form-check-input switch-custom ms-2 mt-2"
                        type="checkbox"
                        name="isSpecial"
                        checked={state?.isSpecial}
                        onChange={switchHandler}
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                </Col>
                <Col md={2}>
                  <div className="form-check form-switch p-0">
                    <label
                      className="d-block text-start"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      {t("newsletter.inFocus")}
                    </label>
                    <div className="row">
                      <input
                        className="form-check-input switch-custom ms-2 mt-2"
                        type="checkbox"
                        name="inFocus"
                        checked={state?.inFocus}
                        onChange={switchHandler}
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                </Col>
                <Col md={2}>
                  <div className="form-check form-switch p-0">
                    <label
                      className="d-block text-start"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      {t("newsletter.jobs")}
                    </label>
                    <div className="row">
                      <input
                        className="form-check-input switch-custom ms-2 mt-2"
                        type="checkbox"
                        name="jobs"
                        checked={state?.jobs}
                        onChange={switchHandler}
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                </Col>
                <Col md={2}>
                  <div className="form-check form-switch p-0">
                    <label
                      className="d-block text-start"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      {t("newsletter.isMarketing")}
                    </label>
                    <div className="row">
                      <input
                        className="form-check-input switch-custom ms-2 mt-2"
                        type="checkbox"
                        name="isMarketing"
                        checked={state?.isMarketing}
                        onChange={switchHandler}
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                </Col>
                <Col md={12} className="my-3" id="custom-editor">
                  <RichTextEditor
                    label={t("newsletter.mr")}
                    value={state?.textMan ?? ""}
                    onChange={(newContent) =>
                      setState((prev: any) => ({
                        ...prev,
                        textMan: newContent,
                      }))
                    }
                  />

                  {/* <label htmlFor="title" className="required-field">
                    {t("newsletter.mr")}
                  </label>
                  <textarea
                    className="editor textMan"
                    onChange={console.log}
                  ></textarea> */}
                  {/* <N1ED
                    id={`textMan`}
                    onFocus={(e) => setSelectEditor(true)}
                    apiKey={process.env.REACT_APP_EDITOR_KEY}
                    value={state?.textMan ?? ""}
                    toolbar={
                      "undo redo | blocks | bold italic forecolor | alignleft aligncenter alignright alignjustify| bullist numlist | outdent indent | removeformat"
                    }
                    // initialValue={
                    //   editorData ? editorData : state?.textMan ?? ""
                    // }
                    onEditorChange={changeEditorHandler}
                  /> */}
                  {/* <CKEditor
                    config={editorConfigurationCustom}
                    editor={Editor}
                    data={state?.textMan ?? ""}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      changeHandlerEditor(data, "textMan");
                    }}
                  /> */}
                </Col>
                <Col md={12} className="mb-3" id="custom-editor">
                  <RichTextEditor
                    label={t("newsletter.woman")}
                    value={state?.textWoman ?? ""}
                    onChange={(newContent) =>
                      setState((prev: any) => ({
                        ...prev,
                        textWoman: newContent,
                      }))
                    }
                  />
                  {/* <label htmlFor="title" className="required-field">
                    {t("newsletter.woman")}
                  </label>
                  <textarea
                    className="editor textWoman"
                    onChange={console.log}
                  ></textarea> */}
                  {/* <N1ED
                    id={`textWoman`}
                    onFocus={(e) => setSelectEditor(true)}
                    apiKey={process.env.REACT_APP_EDITOR_KEY}
                    value={state?.textWoman ?? ""}
                    toolbar={
                      "undo redo | blocks | bold italic forecolor | alignleft aligncenter alignright alignjustify| bullist numlist | outdent indent | removeformat"
                    }
                    // initialValue={
                    //   editorData ? editorData : state ? state?.textWoman : ""
                    // }
                    onEditorChange={changeEditorHandler}
                  /> */}
                  {/* <CKEditor
                    config={editorConfigurationCustom}
                    editor={Editor}
                    data={state?.textWoman ?? ""}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      changeHandlerEditor(data, "textWoman");
                    }}
                  /> */}
                </Col>
                <Col md={12} className="mb-3" id="custom-editor">
                  <RichTextEditor
                    label={t("newsletter.other")}
                    value={state?.textOther ?? ""}
                    onChange={(newContent) =>
                      setState((prev: any) => ({
                        ...prev,
                        textOther: newContent,
                      }))
                    }
                  />
                  {/* <label htmlFor="title" className="required-field">
                    {t("newsletter.other")}
                  </label>
                  <textarea
                    className="editor textOther"
                    onChange={console.log}
                  ></textarea> */}
                  {/* <N1ED
                    id={`textOther`}
                    onFocus={(e) => setSelectEditor(true)}
                    apiKey={process.env.REACT_APP_EDITOR_KEY}
                    value={state?.textOther ?? ""}
                    toolbar={
                      "undo redo | blocks | bold italic forecolor | alignleft aligncenter alignright alignjustify| bullist numlist | outdent indent | removeformat"
                    }
                    // initialValue={
                    //   editorData ? editorData : state ? state?.textOther : ""
                    // }
                    onEditorChange={changeEditorHandler}
                  /> */}
                  {/* <CKEditor
                    config={editorConfigurationCustom}
                    editor={Editor}
                    data={state?.textOther ?? ""}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      changeHandlerEditor(data, "textOther");
                    }}
                  /> */}
                </Col>
              </Row>
            </div>
          </div>
          <div className="col-12">
            <DraggableBootstrapTable
              list={selectedNews}
              setList={setSelectedNews}
              headers={["id", "title", "series"]}
              title="news"
              haveActions={false}
            />
          </div>
        </>
      )}
    </>
  );
};
